import React from "react";
import digitalImg from "../../../assets/images/marketing-translation/digital.webp";
import tranditionalImg from "../../../assets/images/marketing-translation/traditional.webp";

function NewMarkets() {
  return (
    <section className="bg-darkBlue pt-16 pb-20 lg:pt-20 lg:pb-24">
      <div className="w-11/12 lg:w-8/12 xl:max-w-6xl 2xl:w-7/12 mx-auto">
        <h2 className="font-secondary font-semibold text-[35px] text-gray text-center mb-8">
          Reaching <span className="text-orange">New Markets</span> With the Power of Translation
        </h2>
        <p className="text-darkMist text-17 text-center">
          Tomedes can provide expert marketing translations for all your marketing materials with 24/7 support for 120+ languages. We have a 97% client satisfaction rate, because the client is at the
          heart of our philosophy. We believe in putting the client first, so when it comes to marketing translations, rest assured you’ll have the best.
        </p>
        <div className="divider border-b border-gray my-14 border-opacity-25 lg:w-[120%] lg:ml-[-10%]"></div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-40">
          <div>
            <h3 className="font-secondary font-semibold text-[32px] text-gray mt-7 mb-4">
              Localized <span className="text-orange">Content</span> is King
            </h3>
            <p className="text-darkMist text-17">
              Marketing translation services are the key to localizing your marketing documents so that they communicate effectively with foreign language audiences. Localized content allows your
              audience in different regions, speaking different languages, to connect with your content.
            </p>
          </div>
          <div>
            <h4 className="font-secondary font-medium text-[18px] text-gray mt-7 mb-4">Engage your customers in their language</h4>
            <div className="divider2 border-b-2 border-[#201A25] mb-6 mt-3"></div>
            <p className="text-darkMist text-17">
              The key to successful local marketing is customer engagement, and that means engaging your audience through multilingual and localized ways. Marketing translation services enable you to
              understand the wants and needs of your international customers, in the very languages they speak.
            </p>
            <h4 className="font-secondary font-medium text-[18px] text-gray mt-7 mb-4">Break cultural barriers</h4>
            <div className="divider2 border-b-2 border-[#201A25] mb-6 mt-3"></div>
            <p className="text-darkMist text-17">
              Effective marketing translation services enable you to overcome cultural barriers and eliminate linguistic misunderstandings. Breaking cultural barriers in turn drives customer loyalty.
              Tomedes translators are experts in adapting your brand messages to the local marketing languages, so you’re speaking first-hand to your target audience.
            </p>
          </div>
        </div>
        <div className="divider border-b border-gray my-14 border-opacity-25 lg:w-[120%] lg:ml-[-10%]"></div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-40">
          <h3 className="font-secondary font-semibold text-[32px] text-gray mt-7 mb-4">
            <span className="text-orange">Marketing</span> translation services done by marketing professionals
          </h3>
          <p className="text-darkMist text-17">
            Tomedes’ network of translators are trained as experts in more than 120 languages and 950+ language pairs. Our translators are trained in adapting your marketing content, advertising copy,
            social media software apps, and website pages for effective communication to any locale. Our expert project managers, meanwhile, can help you devise and implement an optimal localization
            strategy that’s just right for your needs.
          </p>
        </div>
        <div className="divider border-b border-gray my-14 border-opacity-25 lg:w-[120%] lg:ml-[-10%]"></div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-40">
          <h3 className="font-secondary font-semibold text-[32px] text-gray mt-7 mb-4">
            <span className="text-orange">On time</span> delivery
          </h3>
          <p className="text-darkMist text-17">
            Tomedes marketing translation services are not just high quality, but also high speed. We understand that on-time delivery and cost-effective pricing are key to achieving a rapid return of
            investment (ROI) when it comes to local marketing communications. That’s what you get once you get started with Tomedes.
          </p>
        </div>
        <div className="divider border-b border-gray my-14 border-opacity-25 lg:w-[120%] lg:ml-[-10%]"></div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-40">
          <h3 className="font-secondary font-semibold text-[32px] text-gray mt-7 mb-4">
            <span className="text-orange">Quality</span> Guaranteed
          </h3>
          <p className="text-darkMist text-17">
            The Tomedes quality guarantee extends to all our marketing translation services. Even after delivery of our final product, we remain by your side, ready to assist, fine-tune, or adjust the
            translations to optimize its effectiveness. Other agencies offer guarantees of weeks or months, if any. We guarantee our work for a full year.
          </p>
        </div>
      </div>
    </section>
  );
}

export default NewMarkets;
